import script from "./ButtonsMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonsMessage.vue?vue&type=script&setup=true&lang=js"

import "./ButtonsMessage.vue?vue&type=style&index=0&id=a64dd08c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a64dd08c"]])

export default __exports__